module.exports = __webpack_public_path__ + "static/assets/1c871bb19477ff44e2b339bb99ceb935.svg";